import { NonNullableSettingConfig } from "./NonNullableSettingConfig";

export const StringSetting: NonNullableSettingConfig<string> = {
  type: "string",
  serialize: (value: string): string => {
    return value;
  },

  deserialize: (value: string): string => {
    return value;
  },
};
